// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"228":"0c3156e981b4825e","537":"97d59616ff0b132d"}[chunkId] + ".js";
};